import React from 'react';
import { AkashicLanding } from './pages/AkashicLanding';
function App() {
  return <AkashicLanding data-id="element-0" />;
}
export { App };